module.exports = __webpack_public_path__ + "static/media/alert.cdf9c2de.svg";